import React from 'react';
import styled from 'styled-components/macro';
import NumberInput from 'components/Input/NumberInput';
import { UserDecimalSep } from 'models/user';

const InputWrapper = styled.div<{
  display?: string;
  margin?: string;
}>`
  display: ${({ display }) => display ?? 'flex'};
  justify-content: flex-start;
  align-items: center;
  margin: ${({ margin }) => margin ?? '0'};
`;

const InputLabel = styled.span`
  display: inline-block;
  margin-right: 15px;
  font-size: ${({ theme }) => theme.fontSizePalette.xxSmall};
  width: 100px;
  text-align: right;
  overflow: hidden;
  letter-spacing: -0.31px;
  color: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey10 : theme.colorPalette.grey.grey9};
`;

export interface Props {
  label: string;
  disabled?: boolean;
  onChange: (value?: number) => void;
  onFocus: (value?: number) => void;
  onBlur: (value?: number) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>) => void;
  readonly: boolean;
  value: number;
  decimalSeparator: UserDecimalSep;
  hasFixedDecimals?: boolean;
  decimalScale?: number;
  feedbackColor?: string;
  hasFeedback?: boolean;
  feedbackMessage?: string;
  multi?: boolean;
  width?: string;
  display?: string;
  margin?: string;
}

const NumberInputType = (props: Props) => {
  const {
    label,
    readonly,
    onChange,
    onBlur,
    onFocus,
    onKeyDown,
    decimalSeparator,
    hasFixedDecimals = false,
    decimalScale,
    hasFeedback = false,
    feedbackColor,
    feedbackMessage,
    multi,
    value,
    width,
    display,
    margin,
  } = props;

  return (
    <InputWrapper display={display} margin={margin}>
      {!multi ? <InputLabel>{label}</InputLabel> : null}
      <NumberInput
        hasFeedback={hasFeedback}
        feedbackMessage={feedbackMessage}
        feedbackColor={feedbackColor}
        decimalScale={decimalScale}
        readOnly={readonly}
        value={value}
        decimalSeparator={decimalSeparator}
        hasFixedDecimals={hasFixedDecimals}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        width={width}
        height="30px"
        fontSize='0.9rem'
      />
    </InputWrapper>
  );
};

export default NumberInputType;
